import { ESIndex } from '../../../types';
import { useTranslation } from '../../../hooks/useTranslation';

export const useEventFieldplaceholder = (isUserField: boolean, esIndex?: ESIndex) => {
  const { t } = useTranslation();
  if (esIndex === ESIndex.Catalog) return t('v2.conditionBuilder.singleCatalogFieldPlaceholder');
  return t(
    isUserField
      ? 'v2.conditionBuilder.singleUserFieldPlaceholder'
      : 'v2.conditionBuilder.singleEventFieldPlaceholder',
  );
};
